import * as exTreetable from './mount';
import type { TypeManagerApi, TypeManagerConfig } from './mount';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLTableElement {
        treetable(config?: TypeManagerConfig): TypeManagerApi | undefined;
    }
}

// ----------------------------------------------------------------------------

HTMLTableElement.prototype.treetable = function (config?: TypeManagerConfig): TypeManagerApi | undefined {
    return exTreetable.mount(this, config);
};
